import p5 from 'p5';
import { isRender } from './infra';

// common to all sketches
export const maxFrames = 600;
export const rate = 30;

// useful for displaying numbers
export const formatter = new Intl.NumberFormat('en-US', {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

/**
 * https://easings.net/#easeInOutSine
 */
export function easeInOutSine(x) {
	return -(Math.cos(Math.PI * x) - 1) / 2;
}

export function smoothstep(min, max, value) {
	const x = Math.max(0, Math.min(1, (value - min) / (max - min)));
	return x * x * (3 - 2 * x);
}

export function clamp(num, min, max) {
	return Math.min(Math.max(num, min), max);
}

/*
 * Utility so I may use normalized coordinates, i.e. between [0,1] for width and height.
 */
export function w(val) {
	return val * width;
}

/*
 * Utility so I may use normalized coordinates, i.e. between [0,1] for width and height.
 */
export function h(val) {
	return val * height;
}

/**
 * Returns the desired canvas size for a P5 sketch. Max is 1080x1080, min is a little less than window width.
 */
export function getCanvasSize() {
	return Math.min(1080, Math.round(Math.min(windowWidth, windowHeight) * 0.95));
}

export function windowResized() {
	const size = getCanvasSize();
	resizeCanvas(size, size);
}

export function setupCommon() {
	const size = getCanvasSize();
	createCanvas(size, size);
	frameRate(rate);

	colorMode(HSB, 360, 100, 100, 1.0);

	textSize(w(0.03));
	textAlign(CENTER);

	noFill();
	noStroke();
}

export let frame = 0;
export let frameN = 0;

export function setFrameN(val) {
  frameN = val;
}

export function drawCommon() {
	if (isRender && frameCount === 1) {
    // P5Capture does not support module bundlers so I will disable it.
    //
		// const capture = P5Capture.getInstance();
		// capture.start();
    console.warn("P5Capture does not support module bundling and is disabled");
	}

	frame = frameCount % maxFrames;
	frameN = (frame / maxFrames);
}
